import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
      items: [],
      homepage_data: {},
      profiles: {},
      restrictions : [],
      stickers : [],
      // null until /general answers — an empty object would read as a logged-in
      // user to every `!!get_me` check during that window.
      user : null,
      // Signup modal trigger: null = closed, object = { step: 1|2, plan_id: 0|N }
      signup_open: null,
    },
    mutations: {
        update_item (state, item) {

          state.items[item.id] = item;
        },
        open_search (state) {

          state.is_search_opened = true;
        },
        // Open the login modal in signup mode.
        // payload: { step: 1|2, plan_id: 0|N }
        open_signup (state, payload) {
          state.signup_open = payload || { step: 1, plan_id: 0 };
        },
        close_signup (state) {
          state.signup_open = null;
        },
    },
    getters: {
        
        get_item: (state) => (id) => {
            //return getters.doneTodos.length

            return state.items[id]; 


          }
      }
      
  });
 // store.commit('update_article', {} );